export default __webpack_public_path__ + "static/media/Vector.0aa00ee9.svg";